export default {
  namespaced: true,
  state: {
    loading: true,
    results: [],
  },
  mutations: {
    SET_DATA: (state, data) => {
      var results = [];
      data.filter((d) => {
        d.deleting = false;
        d.setting = false;
        results.push(d);
      });
      state.results = results;
      state.loading = false;
    },
    ADD_CONTACT: (state, contact) => {
      contact.deleting = false;
      state.results.push(contact);
    },
    DELETE_CONTACT: (state, contact) => {
      var results = state.results.filter((c, key) => {
        if (c.id == contact.id) {
          delete state.results[key];
        } else {
          return c;
        }
      });
      state.results = results;
    },
  },
  actions: {
    get: function ({ commit, dispatch }, id) {
      this.$http
        .get(`vendors/${id}/contacts`)
        .then((res) => {
          if (res.status == 200) {
            commit("SET_DATA", res.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setError",
            {
              message: err.message,
              code: 1,
            },
            { root: true }
          );
        });
    },
    save: function ({ commit, dispatch }, payload) {
      commit("SET_SAVING_STATE", true, { root: true });

      this.$http
        .post(`vendors/${payload.vendor}/contacts`, payload.contact)
        .then((res) => {
          if (res.status == 200) {
            commit("SET_SAVING_STATE", false, { root: true });
            commit("ADD_CONTACT", res.data.data.contact);
            dispatch("hideModal", null, { root: true });
          }
        })
        .catch((err) => {
          dispatch(
            "setError",
            {
              message: err.message,
              code: 1,
            },
            { root: true }
          );
        });
    },
    delete: function ({ commit, dispatch }, contact) {
      this.$http
        .delete(`vendors/${contact.vendor_id}/contacts/${contact.id}`)
        .then((res) => {
          if (res.status == 200) {
            commit("DELETE_CONTACT", contact);
          }
        })
        .catch((err) => {
          dispatch(
            "setError",
            {
              message: err.message,
              code: 1,
            },
            { root: true }
          );
        });
    },
    updatePrimary: function ({ dispatch }, contact) {
      let vm = this;
      return new Promise(function (resolve) {
        return vm.$http
          .post(`vendors/contacts/${contact.id}/update-primary`, {
            is_primary_contact: !contact.is_primary_contact,
          })
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    attachUserToVendor: async function ({ commit, dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`vendors/${payload.vendor}/attach`, {
            contact: payload.contact,
            is_primary_contact: payload.primaryContact,
          })
          .then(async function (res) {
            if (res.status == 200) {
              commit("SET_SAVING_STATE", false, { root: true });
              await dispatch("get", payload.vendor);
              await dispatch("hideModal", null, { root: true });
            }
            return resolve(true);
          })
          .catch((err) => {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
  },
};
